export enum ObjectType {
  ad = 2,
  advertiser = 1,
}

export enum MonitorStatus {
  active = 0,
  inactive = 1,
  delete = -1,
}

export interface Rule {
  template_id: string;
  conditions: Array<{
    period: number;
    field: string;
    operator: string;
    values: Array<string | number>;
    extra?: boolean;
  }>
}

export interface MonitorRule {
  rule_type: string;
  schedule_type: string;
  rules: Array<Rule>
}

export interface MonitorData {
  monitor_id: number;
  monitor_name: string;
  monitor_status: MonitorStatus;
  object_type: ObjectType;
  objects: {
    account_label_list: Array<number>;
    uid_list: Array<number>;
  };
  schedule: {
    days: Array<number>;
    time_range: {
      start_time: string;
      end_time: string;
    }
  };
  rule_list: Array<MonitorRule>;
};

export enum UserBehavior {
  ignored = 2,
}
